import { createContext, ReactNode, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import defaults from 'lodash/defaults';
import { messages as AwaitingMessages } from '../../AwaitingCredentialsScreen/organisms/AwaitingMobileBankIdAuthenticationContainer/molecules/AwaitingMobileBankIdAuthenticationTarget/messages';
import { messages as LoadingOverlayMessages } from '../../../../core/screens/LoadingOverlay/messages';

export type CredentialsCopy = {
  heading: ReactNode;
  initializeProductLoading: ReactNode;
};

export const defaultCredentialsCopy: CredentialsCopy = {
  heading: <FormattedMessage {...AwaitingMessages.connectTitle} />,
  initializeProductLoading: <FormattedMessage {...LoadingOverlayMessages.label} />,
};

/**
 * Use this to override any part of the copy.
 */
export const CredentialsCopyContext =
  createContext<Partial<CredentialsCopy>>(defaultCredentialsCopy);

/**
 * !! PLEASE DON'T OVERUSE THIS !!
 *
 * We've added this context to avoid prop drilling from the main credentials
 * component down to individual screens, but we think that we should flatten
 * out the hierarchy and use explicit props.
 *
 * Try to use it from machine views and pass the relevant props down to the
 * screens, even if they have to pass through a couple of levels.
 */
export const useCredentialsCopy = (): CredentialsCopy => {
  const value = useContext(CredentialsCopyContext);

  return defaults(value, defaultCredentialsCopy);
};
